import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarTuksom2 extends Component {
  state = { registered: {} };
  seminar = "tuksom"; // ✅ Unique seminar key

  componentDidMount() {
    this.fetchRegistered();
    // Auto-refresh every 10 seconds for real-time sync
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch registration list from backend
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Error fetching registered list:", err);
    }
  };

  // ✅ Handle register/unregister
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 blue = available / 🔴 red = registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Aikido Tuksom Dojo Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Mr. Natthaphat Ingsakulsomboon")}
        <br />
        {this.renderParticipant(2, "Mr. Jacques Adam du Plessis")}
        <br />
        {this.renderParticipant(3, "นายณัฐสุทธิ์ หัตถกรรม")}
        <br />
        {this.renderParticipant(4, "ด.ญ. อนันตญา กุลธนากร")}
        <br />
        {this.renderParticipant(5, "นางสาวมนัสพร เอกวิสิฐ")}
        <br />
        {this.renderParticipant(6, "Mr. Choosak Phumueang")}
        <br />
        {this.renderParticipant(7, "Mr. Chatchawan Egawarin")}
        <br />
        {this.renderParticipant(8, "นายฐาน์กุญช์ แก้วอิสราพันธ์")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarTuksom2;
